// extracted by mini-css-extract-plugin
export default {"form":"AddEventModalForm_form__pNEQr","input":"AddEventModalForm_input__aaYN6"};